import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
      />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lexend:wght@300;400;700;900&display=swap');

        .nf-root {
          min-height: 100vh;
          background: #050e36;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-family: 'Lexend', sans-serif;
          overflow: hidden;
          position: relative;
          padding: 2rem;
        }

        /* Animated background grid */
        .nf-root::before {
          content: '';
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(21, 158, 236, 0.07) 1px, transparent 1px),
            linear-gradient(90deg, rgba(21, 158, 236, 0.07) 1px, transparent 1px);
          background-size: 60px 60px;
          animation: gridDrift 20s linear infinite;
        }

        @keyframes gridDrift {
          0% { background-position: 0 0; }
          100% { background-position: 60px 60px; }
        }

        /* Glowing orbs */
        .orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.25;
          pointer-events: none;
        }
        .orb-1 {
          width: 500px; height: 500px;
          background: #1a3aa1;
          top: -150px; left: -150px;
          animation: float1 8s ease-in-out infinite;
        }
        .orb-2 {
          width: 350px; height: 350px;
          background: #159EEC;
          bottom: -100px; right: -100px;
          animation: float2 10s ease-in-out infinite;
        }

        @keyframes float1 {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(40px, 30px); }
        }
        @keyframes float2 {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(-30px, -20px); }
        }

        .nf-content {
          position: relative;
          z-index: 10;
          text-align: center;
          max-width: 700px;
        }

        /* Giant A icon */
        .nf-icon-wrap {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
        }

        .nf-icon-ring {
          width: 140px;
          height: 140px;
          border-radius: 50%;
          border: 2px solid rgba(21, 158, 236, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          animation: pulse-ring 3s ease-in-out infinite;
        }

        .nf-icon-ring::before {
          content: '';
          position: absolute;
          inset: -10px;
          border-radius: 50%;
          border: 1px solid rgba(21, 158, 236, 0.2);
          animation: pulse-ring 3s ease-in-out infinite 0.5s;
        }

        @keyframes pulse-ring {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.7; }
        }

        .nf-icon-ring i {
          font-size: 4rem;
          color: #159EEC;
          text-shadow: 0 0 30px rgba(21, 158, 236, 0.8);
        }

        /* 404 number */
        .nf-404 {
          font-size: clamp(7rem, 20vw, 12rem);
          font-weight: 900;
          line-height: 1;
          letter-spacing: -4px;
          background: linear-gradient(135deg, #ffffff 0%, #159EEC 50%, #1a3aa1 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 0.5rem;
          animation: fadeUp 0.8s ease both;
        }

        .nf-divider {
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, #1a3aa1, #159EEC);
          margin: 1rem auto;
          border-radius: 2px;
          animation: fadeUp 0.8s ease 0.2s both;
        }

        .nf-title {
          font-size: clamp(1.5rem, 4vw, 2.2rem);
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 0.75rem;
          animation: fadeUp 0.8s ease 0.3s both;
        }

        .nf-subtitle {
          font-size: 1.05rem;
          font-weight: 300;
          color: rgba(255,255,255,0.55);
          margin-bottom: 2.5rem;
          line-height: 1.7;
          animation: fadeUp 0.8s ease 0.4s both;
        }

        /* Buttons */
        .nf-actions {
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
          animation: fadeUp 0.8s ease 0.5s both;
          margin-bottom: 3rem;
        }

        .btn-primary-nf {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.85rem 2rem;
          background: linear-gradient(135deg, #1a3aa1, #159EEC);
          color: white;
          font-family: 'Lexend', sans-serif;
          font-weight: 600;
          font-size: 0.95rem;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 4px 20px rgba(21, 158, 236, 0.35);
        }

        .btn-primary-nf:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 30px rgba(21, 158, 236, 0.5);
          color: white;
          text-decoration: none;
        }

        .btn-outline-nf {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.85rem 2rem;
          background: transparent;
          color: rgba(255,255,255,0.7);
          font-family: 'Lexend', sans-serif;
          font-weight: 400;
          font-size: 0.95rem;
          border: 1px solid rgba(255,255,255,0.2);
          border-radius: 50px;
          cursor: pointer;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .btn-outline-nf:hover {
          border-color: #159EEC;
          color: #159EEC;
          text-decoration: none;
        }

        /* Countdown */
        .nf-countdown {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          padding: 0.6rem 1.4rem;
          background: rgba(21, 158, 236, 0.08);
          border: 1px solid rgba(21, 158, 236, 0.2);
          border-radius: 50px;
          color: rgba(255,255,255,0.45);
          font-size: 0.85rem;
          font-weight: 300;
          animation: fadeUp 0.8s ease 0.6s both;
        }

        .nf-countdown-num {
          color: #159EEC;
          font-weight: 700;
          font-size: 1rem;
          min-width: 1.5ch;
          display: inline-block;
          text-align: center;
        }

        /* Progress bar */
        .nf-progress {
          width: 200px;
          height: 2px;
          background: rgba(255,255,255,0.1);
          border-radius: 2px;
          margin: 0.75rem auto 0;
          overflow: hidden;
          animation: fadeUp 0.8s ease 0.7s both;
        }

        .nf-progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #1a3aa1, #159EEC);
          border-radius: 2px;
          animation: drain 10s linear forwards;
          transform-origin: left;
        }

        @keyframes drain {
          from { width: 100%; }
          to { width: 0%; }
        }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div className="nf-root">
        <div className="orb orb-1" />
        <div className="orb orb-2" />

        <div className="nf-content">

          {/* Icon */}
          <div className="nf-icon-wrap">
            <div className="nf-icon-ring">
              <i className="bi bi-compass" />
            </div>
          </div>

          {/* 404 */}
          <div className="nf-404">404</div>
          <div className="nf-divider" />

          <h1 className="nf-title">Page Not Found</h1>
          <p className="nf-subtitle">
            Looks like you've wandered off the path.<br />
            The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Actions */}
          <div className="nf-actions">
            <a href="/" className="btn-primary-nf">
              <i className="bi bi-house-fill" />
              Go Home
            </a>
            <button onClick={() => navigate(-1)} className="btn-outline-nf">
              <i className="bi bi-arrow-left" />
              Go Back
            </button>
          </div>

          {/* Countdown */}
          <div className="nf-countdown">
            <i className="bi bi-clock" />
            Redirecting to home in <span className="nf-countdown-num">{countdown}</span>s
          </div>

          <div className="nf-progress">
            <div className="nf-progress-fill" />
          </div>

        </div>
      </div>
    </>
  );
};

export default NotFound;